import { $ } from 'hanako-ts/dist/Framework';
import { Elem } from 'hanako-ts/dist/Collection/Types';
import { Collection } from 'hanako-ts/dist/Collection';

function styleTextNodes(element: Elem): void {
  var span = document.createElement('span');

  var textNodes: Collection = new Collection();
  (function recursiveWalk(node: Elem) {
    if (!node) return;

    var childNode: ChildNode | null = node.firstChild;
    while (childNode != null) {
      if (childNode.nodeType == 3) {
        textNodes.add(<Elem>childNode);
      } else if (node.nodeType == 1) {
        recursiveWalk(<Elem>childNode);
      }
      childNode = childNode.nextSibling;
    }
  })(element);

  textNodes.forEach((textNode: Elem) => {
    var dummy: DocumentFragment = document.createDocumentFragment();
    var text = textNode.textContent;
    var tempNode: Node;

    for (var index = 0; index < text.length; index++) {
      tempNode = span.cloneNode(true);
      tempNode.textContent = text[index];
      dummy.appendChild(tempNode);
    }

    var parentNode = textNode.parentNode;

    if (parentNode) parentNode.replaceChild(dummy, textNode);
  });
}

export class Typewriter {
  private item: Collection;
  private callback: Function;
  private callbackCalled: boolean;
  private interval: number = 0;
  private appritionIndex: number = 0;
  private isappearing: boolean = true;

  constructor(item: Collection, callback: Function) {
    this.item = item
    this.callback = callback;
    this.callbackCalled = false;

    this.render();
  }

  private render(): void {
    const element = this.item.get(0);

    element.style.width = parseFloat(getComputedStyle(element, null).width.replace('px', '')) + 'px';
    element.style.height = parseFloat(getComputedStyle(element, null).height.replace('px', '')) + 'px';

    styleTextNodes(element);

    $(this.item).attr('data-appearing', '');

    clearInterval(this.interval);

    setTimeout(() => {
      var speed: number = (element.tagName == 'P') ? 15 : 30;
      var step: number = 0;

      this.interval = window.setInterval(() => {
        var nextSpans: Collection;

        var range: number = Math.ceil(Math.pow(step, step / (100 - step)));
        nextSpans = new Collection();

        $(this.item).find('span:not(.visible)').forEach((item: Elem, index: number) => {
          if (index < range) nextSpans.add(item);
        });

        if ((this.item.hasAttr('data-appear-block') || this.item.find('span.visible').length >= this.item.find('span').length / 1) && !this.callbackCalled) {
          this.item.attr('data-appeared', '');
          this.item.removeAttr('data-appearing');
          this.item.removeAttr('data-appear-element');

          this.callbackCalled = true;

          this.callback();
        }

        if (nextSpans.length == 0) {
          clearInterval(this.interval);

          $(this.item).find('span').forEach((child: Elem) => {
            if ($(this.item).hasClass('map-container') || $(child).hasClass('corner')) return;

            child.replaceWith(child.textContent);
          });

          element.style.width = '';
          element.style.height = '';

          this.isappearing = false;
        } else {
          nextSpans.addClass('visible');
        }

        step++;
      }, speed);
    }, (this.appritionIndex == 0) ? 150 : 40);
  }
}
